import { useState } from 'react'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useRepository } from '@/ui/state/repositoryContext'
import { wipeAllLocalData } from '@/application/library/wipeAllLocalData'

/**
 * PRD #8 — wipe everything local. Two-step confirm before invoking
 * `wipeAllLocalData` to avoid catastrophe on a stray click.
 */
export function WipeLocalDataButton() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const repo = useRepository()
  const [confirming, setConfirming] = useState(false)
  const [busy, setBusy] = useState(false)

  async function doWipe() {
    setBusy(true)
    try {
      await wipeAllLocalData(repo)
      void navigate('/', { replace: true })
      // Force the library to re-fetch by reloading. Simpler than
      // wiring a global "everything changed" event in 1.2.
      window.location.reload()
    } finally {
      setBusy(false)
      setConfirming(false)
    }
  }

  if (!confirming) {
    return (
      <button
        type="button"
        onClick={() => setConfirming(true)}
        className="text-xs underline"
        style={{ color: 'var(--color-muted)' }}
      >
        {t('wipe.label')}
      </button>
    )
  }

  return (
    <span className="text-xs flex items-center gap-2">
      <span style={{ color: 'var(--color-muted)' }}>{t('wipe.confirm')}</span>
      <button
        type="button"
        onClick={doWipe}
        disabled={busy}
        className="rounded px-2 py-0.5"
        style={{ background: 'var(--color-down)', color: 'var(--color-accent-fg)' }}
      >
        {t('wipe.yes')}
      </button>
      <button
        type="button"
        onClick={() => setConfirming(false)}
        className="underline"
        style={{ color: 'var(--color-muted)' }}
      >
        {t('wipe.no')}
      </button>
    </span>
  )
}
